import { Skeleton } from '@repo/ui';

export const AttorneyResponseSkeleton = () => {
  return (
    <div className="flex flex-col gap-6 text-sm text-xtnd-dark dark:text-xtnd-light">
      {/* Appeal Option Selector Skeleton */}
      <div className="flex flex-row gap-4 w-full">
        {/* No Appeal Card Skeleton */}
        <div className="flex items-start gap-3 p-4 rounded-lg border border-gray-300 dark:border-xtnd-dark-600 bg-white dark:bg-xtnd-dark-800 flex-1">
          <Skeleton variant="circular" width={20} height={20} className="mt-0.5" />
          <div className="flex-1 space-y-2">
            <Skeleton variant="text" width="40%" height="1rem" />
            <Skeleton variant="text" width="90%" height="0.875rem" />
          </div>
        </div>

        {/* Appeal Card Skeleton */}
        <div className="flex items-start gap-3 p-4 rounded-lg border border-gray-300 dark:border-xtnd-dark-600 bg-white dark:bg-xtnd-dark-800 flex-1">
          <Skeleton variant="circular" width={20} height={20} className="mt-0.5" />
          <div className="flex-1 space-y-2">
            <Skeleton variant="text" width="30%" height="1rem" />
            <Skeleton variant="text" width="95%" height="0.875rem" />
          </div>
        </div>
      </div>

      {/* Divider */}
      <div className="w-full flex justify-center">
        <div className="w-5/6 border-b border-gray-300 dark:border-xtnd-dark-600"></div>
      </div>

      {/* Invoice Details Skeleton */}
      <div className="space-y-4">
        {/* Matter Information Skeleton */}
        <div className="flex items-center gap-4">
          <div className="space-y-2">
            <Skeleton variant="text" width="120px" height="1.5rem" />
            <Skeleton variant="text" width="180px" height="1rem" />
          </div>
        </div>

        {/* Financial and Aging Information Skeleton */}
        <div className="grid grid-cols-2 gap-6">
          {/* Left Column - Financial Details */}
          <div className="flex flex-col gap-4">
            <div className="space-y-1">
              <Skeleton variant="text" width="60px" height="0.875rem" />
              <Skeleton variant="text" width="100px" height="1rem" />
            </div>
            <div className="space-y-1">
              <Skeleton variant="text" width="80px" height="0.875rem" />
              <Skeleton variant="text" width="100px" height="1rem" />
            </div>
            <div className="space-y-1">
              <Skeleton variant="text" width="70px" height="0.875rem" />
              <Skeleton variant="text" width="100px" height="1rem" />
            </div>
          </div>

          {/* Right Column - Aging and Contact Information */}
          <div className="flex flex-col gap-4">
            <div className="space-y-1">
              <Skeleton variant="text" width="140px" height="0.875rem" />
              <Skeleton variant="rectangular" width="80px" height="28px" />
            </div>
            <div className="space-y-1">
              <Skeleton variant="text" width="90px" height="0.875rem" />
              <Skeleton variant="rectangular" width="120px" height="28px" />
            </div>
          </div>
        </div>
      </div>

      {/* Divider */}
      <div className="w-full flex justify-center">
        <div className="w-5/6 border-b border-gray-300 dark:border-xtnd-dark-600"></div>
      </div>

      {/* Line Item Section Skeleton */}
      <div className="space-y-4">
        {/* Header Skeleton */}
        <div className="flex items-center justify-between border-b border-gray-300 dark:border-xtnd-dark-600 pb-2">
          <Skeleton variant="text" width="100px" height="0.875rem" />
          <Skeleton variant="text" width="200px" height="0.75rem" />
        </div>

        {/* Table header (desktop) Skeleton */}
        <div className="hidden md:grid grid-cols-12 gap-4 px-2">
          <Skeleton variant="text" width="60px" height="0.75rem" className="col-span-2" />
          <Skeleton variant="text" width="150px" height="0.75rem" className="col-span-6" />
          <Skeleton variant="text" width="100px" height="0.75rem" className="col-span-3" />
          <Skeleton variant="text" width="50px" height="0.75rem" className="col-span-1" />
        </div>

        {/* Line Item Row Skeleton */}
        <div className="grid grid-cols-1 md:grid-cols-12 gap-3 p-3 border border-gray-300 dark:border-xtnd-dark-600 rounded-lg bg-white dark:bg-xtnd-dark-800">
          <div className="col-span-2 space-y-1">
            <Skeleton
              variant="text"
              width="80px"
              height="0.75rem"
              className="block md:hidden mb-1"
            />
            <Skeleton variant="rectangular" width="100%" height="34px" />
          </div>
          <div className="col-span-6 space-y-1">
            <Skeleton
              variant="text"
              width="70px"
              height="0.75rem"
              className="block md:hidden mb-1"
            />
            <Skeleton variant="rectangular" width="100%" height="60px" />
          </div>
          <div className="col-span-3 space-y-1">
            <Skeleton
              variant="text"
              width="80px"
              height="0.75rem"
              className="block md:hidden mb-1"
            />
            <Skeleton variant="rectangular" width="100%" height="34px" />
          </div>
          <div className="col-span-1 flex items-center justify-center">
            <Skeleton variant="circular" width={20} height={20} />
          </div>
        </div>

        {/* Add new line button Skeleton */}
        <Skeleton variant="text" width="160px" height="1rem" />

        {/* Submit button Skeleton */}
        <div className="mt-4">
          <Skeleton variant="rectangular" width="100%" height="40px" />
        </div>
      </div>
    </div>
  );
};
